/** resp 中的 item 数据类型 */
export interface IDistrictBusiness {
  id: number;
  cinemaCount: number;
  name: string;
  districtId?: number;
}

/**
 * 电影Item
 */
export interface IMovieItem {
  index?: number;
  actor?: string;
  dimensional?: string;
  director?: string;
  id: string | number;
  logo?: string;
  name?: string;
  type?: string;
  idx?: number;
  key?: number;
  alert?: string;
  desc?: string;
  duration?: number;
  language?: string;
  showButton?: boolean;
  showDates?: Array<string>;
}
export interface ICinameItem {
  snackFeature?: any;
  lowPriceTag?: boolean;
  address: string;
  cityId: string;
  distance: number;
  districtId: number;
  onClick: any;
  id: number;
  lowPrice: number;
  name: string;
  features?: any;
  logo?: string;
  lastSessionsShowTime?: any;
  showTime?: boolean;
  noBorder?: boolean;
  dispatch?: any;
  children?: any;
  history?: any;
}
/** 用于菜单的数据 */
export interface IMenuData {
  label: string;
  value: any; // 如果是商圈id
  disabled?: boolean;
  children?: any;
  isLeaf?: boolean;
  cinemaCount?: number;
  districtId?: number; // 如果是区域id
}

/** 接口返回类型 */
export interface IMovieCinemeData {
  hasNext: boolean;
  searches: Array<IMovieItem | null>;
  totalCount: number;
}
export interface ITimeTabItem {
  label?: string;
  date?: string;
  status?: boolean;
  origin?: string;
}
export interface ICinemaMovieSessionInfo {
  btnType?: number;
  isVendor2Single?: any;
  cinemaId?: string | number;
  cinemaName?: string;
  movieId?: string | number;
  movieName?: any;
  showDateTime?: string;
  duration?: number;
  language?: string;
  hallName?: string;
  enLanguage?: string;
  hallEnName?: string;
  dimensional?: string;
  cityId?: string | number;
  districtId?: string | number;
  dfScheduleId?: string | number;
  lowPriceTag?: boolean;
}

// eslint-disable-next-line
export enum EIndexTypes {
  hot = 1,
  cinema = 2,
  future = 3,
}

// eslint-disable-next-line
export enum ActiveMenuType {
  none = 0,
  left = 1,
  right = 2,
}
